// extracted by mini-css-extract-plugin
export default {"tableHeader":"AtentionsTable_tableHeader__i7p1w","headerItem":"AtentionsTable_headerItem__pdorL"};